// StartupPage.js

import React from "react";
import "../components/Styles/StartupPage.css";
import {
  FaBuilding,
  FaShieldAlt,
  FaFileSignature,
  FaUserTie,
  FaBell,
  FaWhatsapp,
} from "react-icons/fa";

function StartupPage() {
  return (
    <div className="lk-startup-page">

      {/* HERO SECTION */}
      <section className="lk-startup-hero">

        <div className="lk-container lk-hero-wrapper">

          <div className="lk-hero-left">

            <span className="lk-hero-tag">
              Trusted Startup Legal Partner
            </span>

            <h1>
              Startup Legal <span>Solutions</span>
            </h1>

            <p>
              Build and grow your startup with trusted legal support,
              company registration, agreements, compliance and startup
              advisory services from experienced lawyers across India.
            </p>

            <div className="lk-hero-buttons">

              <button className="lk-primary-btn">
                Get Started
              </button>

              <button className="lk-secondary-btn">
                Explore Services
              </button>

            </div>

          </div>

        </div>

      </section>

      {/* FEATURES SECTION */}

      <section className="lk-startup-features">

        <div className="lk-container lk-feature-grid">

          {/* LEFT */}

          <div className="lk-feature-left">

            <span className="lk-feature-tag">
              FEATURES
            </span>

            <h2>
              Take correct business decisions with the
              <span> right legal support</span>
            </h2>

            <p className="lk-feature-desc">
              LegalAxis’s Startup service helps founders and businesses with
              company formation, registrations, legal agreements, compliance,
              trademarks, and startup documentation across India.
            </p>

            <div className="lk-feature-list">

              <div className="lk-feature-item">
                <div className="lk-feature-number">01</div>
                <p>Transparent pricing with zero hidden charges.</p>
              </div>

              <div className="lk-feature-item">
                <div className="lk-feature-number">02</div>
                <p>Real-time updates on WhatsApp & Email.</p>
              </div>

              <div className="lk-feature-item">
                <div className="lk-feature-number">03</div>
                <p>Services handled by experienced senior lawyers.</p>
              </div>

              <div className="lk-feature-item">
                <div className="lk-feature-number">04</div>
                <p>No travel required — everything online & hassle-free.</p>
              </div>

              <div className="lk-feature-item">
                <div className="lk-feature-number">05</div>
                <p>Startup legal services available all across India.</p>
              </div>

            </div>

          </div>

          {/* RIGHT */}

          <div className="lk-feature-right">

            <img
              src="https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=1200&auto=format&fit=crop"
              alt=""
            />

          </div>

        </div>

      </section>

      {/* PRODUCTS SECTION */}

      <section className="lk-startup-products">

        <div className="lk-container">

          <div className="lk-section-heading">

            <span className="lk-section-tag">
              STARTUP PRODUCTS
            </span>

            <h2>
              Products for all your Startup Needs
            </h2>

          </div>

          <div className="lk-product-tabs">

            <div className="lk-tab lk-active-tab">
              <FaBuilding />
              <span>Company Formation</span>
            </div>

            <div className="lk-tab">
              <FaShieldAlt />
              <span>Intellectual Property</span>
            </div>

            <div className="lk-tab">
              <FaFileSignature />
              <span>Registrations & Licenses</span>
            </div>

          </div>

          <div className="lk-product-grid">

            {/* CARD 1 */}

            <div className="lk-product-card">

              <div className="lk-discount-badge">
                26% OFF
              </div>

              <h3>
                One Person Company
              </h3>

              <div className="lk-price-area">

                <h1>₹ 12,999</h1>
                <p>₹ 17,499</p>

              </div>

              <ul>

                <li>Separate Legal Existence</li>
                <li>Limited Liability of Shareholders</li>
                <li>Continuous Existence</li>
                <li>Easy Fund Raising</li>

              </ul>

              <button className="lk-know-btn">
                Know More
              </button>

            </div>

            {/* CARD 2 */}

            <div className="lk-product-card">

              <div className="lk-discount-badge lk-purple-badge">
                30% OFF
              </div>

              <h3>
                Limited Liability Partnership
              </h3>

              <div className="lk-price-area">

                <h1>₹ 18,599</h1>
                <p>₹ 26,599</p>

              </div>

              <ul>

                <li>Limited Liability of Partners</li>
                <li>Separate Legal Entity</li>
                <li>Continuity of Existence</li>
                <li>Minimal Regulatory Compliance</li>
                <li>Transferability of Ownership</li>

              </ul>

              <button className="lk-know-btn">
                Know More
              </button>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
}

export default StartupPage;